import {useNavigate } from 'react-router-dom';
import { IoChevronBack } from "react-icons/io5";
import CustomTooltip from './CustomTooltip';

const DisplayPPTPage = ({ heading, pdf }) => {
    const navigate = useNavigate()
    return (
        <div>
            <>
                <header className="topHeader shadow-sm position-fixed top-0 start-0 w-100 bg-white py-2">
                    <div className="container-fluid">
                        <div className="row align-items-center text-center text-md-start">

                            {/* Left Logo */}
                            <div className="col-4 col-md-3 d-flex align-items-center justify-content-start">
                                <img
                                    src={"/assets/img/tml-logo-new.png"}
                                    className="img-fluid"
                                    style={{ maxHeight: "35px" }}
                                    alt="tml-logo"
                                />
                            </div>

                            {/* Heading */}
                            <div className="col-4 col-md-6 d-flex justify-content-center">
                                <h5 className="fw-bold mb-0 text-truncate">
                                    {heading}
                                </h5>
                            </div>

                            {/* Right Section */}
                            <div className="col-4 col-md-3 d-flex align-items-center justify-content-end">

                                <CustomTooltip text="Back to vehicle list" placement="bottom">
                                    <div
                                        onClick={() => navigate(-1)}
                                        className="cursor-pointer border rounded p-2 me-2 bg-light d-flex align-items-center justify-content-center"
                                    >
                                        <IoChevronBack />
                                    </div>
                                </CustomTooltip>

                                <img
                                    src={process.env.PUBLIC_URL + "/assets/img/sp-logo.png"}
                                    className="img-fluid"
                                    style={{ maxHeight: "45px" }}
                                    alt="sp-logo"
                                />
                            </div>

                        </div>
                    </div>
                </header>

                <div className='container pt-2 mt-5'>
                    <iframe
                        src={pdf}
                        className="w-100 mt-2"
                        height="500em"
                        sandbox
                    ></iframe>
                </div>
            </>
        </div>
    );
}

export default DisplayPPTPage;
